import * as types from 'actions/actionTypes'

import initialState from './initialState'

export const resignation = (state = initialState.resignations, action) => {
  let index, allApprovals, rtApprovals

  switch (action.type) {
    case types.FETCH_RESIGNATION_APPROVALS_SUCCESS:
      return { ...state, approvals: action.payload }
    case types.UPDATE_RESIGNATION_APPROVALS_SUCCESS:
      if (state.approvals.approvals) {
        allApprovals = [...state.approvals.approvals]
        index = state.approvals.approvals.findIndex((ap) => ap.id === action.payload.id)
        if (index !== -1) allApprovals[index] = { ...allApprovals[index], ...action.payload }
      }

      rtApprovals = state.resignationTimeline.approvals
      if (rtApprovals) {
        index = rtApprovals.findIndex((ap) => ap.id === action.payload.id)
        if (index !== -1)
          rtApprovals[index] = {
            ...rtApprovals[index],
            approver_type: action.payload.approver_type,
            approver_id: action.payload.approver_id,
            serialized_approver: action.payload.serialized_approver
          }
      }

      return {
        ...state,
        resignationTimeline: { ...state.resignationTimeline },
        approvals: {
          approvals: allApprovals || [],
          approvalStats: state.approvals.approvalStats || [],
          resignationTimeline: {
            ...state.resignationTimeline,
            approvals: rtApprovals
          }
        }
      }
    case types.CREATE_RESIGNATION_APPROVAL_STATUS_SUCCESS:
      if (state.approvals.approvals) {
        allApprovals = [...state.approvals.approvals]
        index = state.approvals.approvals.findIndex((ap) => ap.id === action.payload.entity_approval_id)
        allApprovals.splice(index, 1)
      }

      var detailPageData = action.payload.detail_page_data
      rtApprovals = state.resignationTimeline.approvals
      if (rtApprovals) {
        index = rtApprovals.findIndex((ap) => ap.id === action.payload.entity_approval_id)
        rtApprovals[index] = { ...rtApprovals[index], status: action.payload.status, active: false }
        const resolvedMaxId = (detailPageData?.auto_approvals || []).reduce(
          (max, ap) => Math.max(max, ap.id),
          action.payload.entity_approval_id
        )
        const nextApproval = [...rtApprovals].sort((a, b) => a.id - b.id).find((ap) => ap.id > resolvedMaxId)
        const nextApprovalIndex = nextApproval ? rtApprovals.findIndex((ap) => ap.id === nextApproval.id) : -1

        if (nextApprovalIndex >= 0 && rtApprovals[nextApprovalIndex]) {
          rtApprovals[nextApprovalIndex] = { ...rtApprovals[nextApprovalIndex], active: true }
        }

        detailPageData?.auto_approvals?.forEach((approval) => {
          const indexAutoApprove = rtApprovals.findIndex((ap) => ap.id === approval.id)
          rtApprovals[indexAutoApprove] = {
            ...rtApprovals[indexAutoApprove],
            status: approval.status
          }
        })
      }
      var hasResignationTimelineData = Object.keys(state.resignationTimeline).length > 0

      return {
        ...state,
        approvals: {
          approvals: allApprovals || [],
          approvalStats: state.approvals.approvalStats || [],
          resignationTimeline: {
            ...state.resignationTimeline,
            approvals: rtApprovals || []
          }
        },
        ...(hasResignationTimelineData && {
          resignationTimeline: {
            ...state.resignationTimeline,
            active_pending_approval_id: detailPageData?.currrent_active_approval_id
          }
        })
      }
    case types.CREATE_RESIGNATION_TIMELINE_SUCCESS:
      return { ...state, userResignationTimeline: action.payload }

    case types.FETCH_USER_RESIGNATION_TIMELINE_SUCCESS:
      return { ...state, userResignationTimeline: action.payload }
    case types.UPDATE_RESIGNATION_TIMELINE_SUCCESS: {
      const { user_id, proposed_lwd, experience_letter_required } = action.payload
      const existingApprovals = state.approvals?.approvals || []
      const updatedApprovals = [...existingApprovals]

      const approvalIndex = updatedApprovals.findIndex((ap) => ap?.employee?.id === user_id)
      if (approvalIndex !== -1) {
        updatedApprovals[approvalIndex] = {
          ...updatedApprovals[approvalIndex],
          proposed_lwd,
          experience_letter_required
        }
      }

      const shouldUpdateResignationTimeline =
        state.resignationTimeline && Object.keys(state.resignationTimeline).length > 0

      return {
        ...state,
        ...(shouldUpdateResignationTimeline && {
          resignationTimeline: {
            ...state.resignationTimeline,
            proposed_lwd,
            experience_letter_required
          }
        }),
        approvals: {
          ...state.approvals,
          approvals: updatedApprovals
        }
      }
    }
    case types.CREATE_RESIGNATION_REVOKE_STATUS_SUCCESS:
      return { ...state, userResignationTimeline: action.payload }
    case types.FETCH_RESIGNATION_TIMELINE_SUCCESS:
      return { ...state, resignationTimeline: action.payload }
    case types.UPDATE_RESIGNATION_OFFBOARDING_DEPENDENCY_SUCCESS: {
      const updatedDependencies = state.resignationTimeline.offboarding_dependencies.map((dep) => {
        const updatedDep = action.payload.find((p) => p.id === dep.id)
        return updatedDep ? { ...dep, ...updatedDep } : dep
      })

      return {
        ...state,
        resignationTimeline: {
          ...state.resignationTimeline,
          offboarding_dependencies: updatedDependencies
        }
      }
    }
    default:
      return state
  }
}
